import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-instructs",
  "use": "icon-instructs-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-instructs\"><defs><style type=\"text/css\"></style></defs><path d=\"M256 64c-38.4 0-64 12.8-64 32v832c0 19.2 25.6 32 64 32s64-12.8 64-32V96c0-19.2-25.6-32-64-32z m64 64l512 288-512 288V128z\" p-id=\"2124\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol